// Sistema padronizado de carrinho para Templates Poderosos
class CarrinhoManager {
  constructor() {
    this.init()
  }

  init() {
    // Adicionar estilos CSS para feedback
    this.addFeedbackStyles()
  }

  // Adicionar produto ao carrinho com loading global
  async addToCart(variantId, quantity = 1, buttonElement = null, customPrice = null, customUnitPrice = null) {
    try {
      // Validar variantId
      if (!variantId || variantId === 'null' || variantId === 'undefined') {
        throw new Error('Variante do produto não encontrada. Por favor, selecione todas as opções do produto.')
      }

      // Converter variantId para número se for string
      const variantIdNum = parseInt(variantId)
      if (isNaN(variantIdNum) || variantIdNum <= 0) {
        throw new Error('ID da variante inválido. Por favor, recarregue a página e tente novamente.')
      }

      // Validar quantidade
      const quantityNum = parseInt(quantity)
      if (isNaN(quantityNum) || quantityNum <= 0) {
        throw new Error('Quantidade inválida.')
      }

      // Mostrar loading no botão se fornecido
      if (buttonElement) {
        this.showLoading(buttonElement)
      }

      // Verificar se o produto já está no carrinho
      let cartData
      try {
        const cartResponse = await fetch('/cart.js')
        if (!cartResponse.ok) {
          throw new Error('Erro ao acessar o carrinho')
        }
        cartData = await cartResponse.json()
      } catch (error) {
        // Continuar mesmo se não conseguir verificar o carrinho
        cartData = { items: [] }
      }

      // Verificar se o produto já existe no carrinho com a mesma variante
      const itemsComMesmaVariante = cartData.items.filter((item) => item.variant_id.toString() === variantIdNum.toString())

      // Coletar configurações do produto (tags de configuração)
      const configuracoes = []

      // Propriedades específicas para produto-featured (Cor, Modelo, Tamanho)
      const propriedadesEspecificas = {}

      // Função auxiliar para coletar texto de um elemento
      const coletarTexto = (elemento, seletor) => {
        if (!elemento) return null
        const textoEl = elemento.querySelector(seletor)
        if (textoEl) {
          const texto = textoEl.textContent.trim()
          return texto || null
        }
        return null
      }

      // Detectar se estamos na página produto-featured e coletar Cor, Modelo e Tamanho
      const corAtiva = document.querySelector('.cor-opcao.ativa')
      if (corAtiva) {
        const corValue = corAtiva.getAttribute('data-cor-value') || corAtiva.getAttribute('title') || corAtiva.getAttribute('data-value') || ''
        if (corValue) {
          propriedadesEspecificas['Cor'] = corValue
        }
      }

      const generoAtivo = document.querySelector('.genero-opcao.ativo')
      if (generoAtivo) {
        const generoValue = generoAtivo.getAttribute('data-genero') || generoAtivo.textContent.trim() || ''
        if (generoValue) {
          // Capitalizar primeira letra
          propriedadesEspecificas['Modelo'] = generoValue.charAt(0).toUpperCase() + generoValue.slice(1)
        }
      }

      const tamanhoAtivo = document.querySelector('.tamanho-opcao.ativo:not(.indisponivel)')
      if (tamanhoAtivo) {
        const tamanhoValue = tamanhoAtivo.getAttribute('data-size-value') || tamanhoAtivo.textContent.trim() || ''
        if (tamanhoValue) {
          propriedadesEspecificas['Tamanho'] = tamanhoValue
        }
      }

      // SEMPRE coletar diretamente das opções ativas (método mais confiável)
      // Formato - IMPORTANTE: deve ser a primeira configuração
      let formatoColetado = false
      const formatoAtivo = document.querySelector('.opcao-item[data-opcao^="formato-"].ativo') ||
                         document.querySelector('.opcao-item-tema2[data-opcao^="formato-"].ativo')
      if (formatoAtivo) {
        // Tentar primeiro o seletor específico do tema2, depois os genéricos
        const textoFormato = coletarTexto(formatoAtivo, '.opcao-texto-formato-tema2') ||
                            coletarTexto(formatoAtivo, '.opcao-texto') ||
                            coletarTexto(formatoAtivo, '.opcao-texto-tema2')
        if (textoFormato) {
          const textoLimpo = textoFormato.split('\n')[0].trim()
          if (textoLimpo) {
            // Adicionar formato como PRIMEIRA configuração
            configuracoes.unshift(textoLimpo)
            formatoColetado = true
          }
        }
      }

      // Se não coletou formato das opções ativas, tentar coletar do resumo ANTES de continuar
      if (!formatoColetado) {
        const tagsContainer = document.getElementById('resumo-tags-configuracao') ||
                             document.getElementById('resumo-tags-configuracao-tema2')
        if (tagsContainer) {
          const tags = tagsContainer.querySelectorAll('.resumo-tag, .resumo-tag-tema2, span')
          // Procurar formato no resumo (geralmente é o primeiro item ou tem padrão "X x Y cm")
          for (let tag of tags) {
            const texto = tag.textContent.trim()
            if (texto && /^\d+[\s,.]*\d*\s*x\s*\d+[\s,.]*\d*\s*cm$/i.test(texto)) {
              configuracoes.unshift(texto)
              formatoColetado = true
              break
            }
          }
        }
      }

      // Impressão
      const impressaoAtiva = document.querySelector('.opcao-item[data-opcao^="impressao-"].ativo') ||
                             document.querySelector('.opcao-item-tema2[data-opcao^="impressao-"].ativo')
      if (impressaoAtiva) {
        const textoImpressao = coletarTexto(impressaoAtiva, '.opcao-texto') ||
                              coletarTexto(impressaoAtiva, '.opcao-texto-tema2')
        if (textoImpressao) {
          const textoLimpo = textoImpressao.trim()
          if (textoLimpo) configuracoes.push(textoLimpo)
        }
      }

      // Papel
      const papelAtivo = document.querySelector('.opcao-item[data-opcao^="papel-"].ativo') ||
                        document.querySelector('.opcao-item-tema2[data-opcao^="papel-"].ativo')
      if (papelAtivo) {
        const textoPapel = coletarTexto(papelAtivo, '.opcao-texto') ||
                          coletarTexto(papelAtivo, '.opcao-texto-tema2')
        if (textoPapel) {
          const textoLimpo = textoPapel.trim()
          if (textoLimpo) configuracoes.push(textoLimpo)
        }
      }

      // Enobrecimento (coletar primeiro, pois no tema2 pode usar data-opcao="acabamento-furo-*")
      // No tema2, a seção "Enobrecimento" pode usar data-opcao="acabamento-furo-*"
      let enobrecimentoAtivo = document.querySelector('.opcao-item[data-opcao^="enobrecimento-"].ativo') ||
                                document.querySelector('.opcao-item-tema2[data-opcao^="enobrecimento-"].ativo')

      // Se não encontrou, procurar na seção de Enobrecimento do tema2
      if (!enobrecimentoAtivo) {
        const secaoEnobrecimento = Array.from(document.querySelectorAll('.configuracao-secao-tema2')).find(secao => {
          const titulo = secao.querySelector('.secao-titulo-tema2')
          return titulo && titulo.textContent.trim() === 'Enobrecimento'
        })
        if (secaoEnobrecimento) {
          enobrecimentoAtivo = secaoEnobrecimento.querySelector('.opcao-item-tema2.ativo')
        }
      }

      let textoEnobrecimento = null
      if (enobrecimentoAtivo) {
        textoEnobrecimento = coletarTexto(enobrecimentoAtivo, '.opcao-texto') ||
                           coletarTexto(enobrecimentoAtivo, '.opcao-texto-tema2')
        if (textoEnobrecimento) {
          const textoLimpo = textoEnobrecimento.trim()
          if (textoLimpo) {
            configuracoes.push(textoLimpo)
          }
        }
      }

      // Acabamento (apenas se não for da seção de Enobrecimento)
      // No tema2, não coletar acabamento se já coletamos enobrecimento da mesma seção
      const acabamentoAtivo = document.querySelector('.opcao-item[data-opcao^="acabamento-"].ativo') ||
                             document.querySelector('.opcao-item-tema2[data-opcao^="acabamento-"].ativo')
      if (acabamentoAtivo) {
        // Verificar se este acabamento não é da seção de Enobrecimento
        const secaoAcabamento = acabamentoAtivo.closest('.configuracao-secao-tema2')
        const ehEnobrecimento = secaoAcabamento && secaoAcabamento.querySelector('.secao-titulo-tema2') &&
                                secaoAcabamento.querySelector('.secao-titulo-tema2').textContent.trim() === 'Enobrecimento'

        // Se não é da seção de Enobrecimento, coletar
        if (!ehEnobrecimento) {
          const textoAcabamento = coletarTexto(acabamentoAtivo, '.opcao-texto') ||
                                 coletarTexto(acabamentoAtivo, '.opcao-texto-tema2')
          if (textoAcabamento) {
            const textoLimpo = textoAcabamento.trim()
            // Verificar se não é duplicata do enobrecimento já coletado
            if (textoLimpo && textoLimpo !== textoEnobrecimento) {
              configuracoes.push(textoLimpo)
            }
          }
        }
      }

      // Extras
      const extrasAtivos = document.querySelectorAll('.opcao-item[data-opcao^="extra-"].ativo, .opcao-item-tema2[data-opcao^="extra-"].ativo')
      extrasAtivos.forEach(extra => {
        const textoExtra = coletarTexto(extra, '.opcao-texto') ||
                          coletarTexto(extra, '.opcao-texto-tema2')
        if (textoExtra) {
          const textoLimpo = textoExtra.replace(/\n/g, ' ').trim()
          // Verificar se não é duplicata antes de adicionar
          if (textoLimpo && !configuracoes.some(config => config.toLowerCase().trim() === textoLimpo.toLowerCase().trim())) {
            configuracoes.push(textoLimpo)
          }
        }
      })

      // SEMPRE tentar coletar do resumo também (pode ter mais configurações)
      // Isso garante que todas as configurações sejam capturadas, especialmente do tema2
      const tagsContainer = document.getElementById('resumo-tags-configuracao') ||
                           document.getElementById('resumo-tags-configuracao-tema2')
      if (tagsContainer) {
        const tags = tagsContainer.querySelectorAll('.resumo-tag, .resumo-tag-tema2, span')
        const configuracoesDoResumo = []
        tags.forEach(tag => {
          const texto = tag.textContent.trim()
          // Ignorar tags vazias ou que sejam apenas espaços
          if (texto && texto.length > 0 && !texto.match(/^\s*$/)) {
            // Verificar se já não está na lista (evitar duplicatas)
            // Também verificar se não é formato (já foi coletado antes se existir)
            const ehFormato = /^\d+[\s,.]*\d*\s*x\s*\d+[\s,.]*\d*\s*cm$/i.test(texto)
            const jaTemFormato = formatoColetado && configuracoes.some(config => /^\d+[\s,.]*\d*\s*x\s*\d+[\s,.]*\d*\s*cm$/i.test(config))

            // Verificar se já existe na lista de configurações (comparação case-insensitive para evitar duplicatas)
            const jaExiste = configuracoes.some(config => config.toLowerCase().trim() === texto.toLowerCase().trim())
            const jaExisteNoResumo = configuracoesDoResumo.some(config => config.toLowerCase().trim() === texto.toLowerCase().trim())

            if (!jaExiste && !jaExisteNoResumo) {
              // Se é formato e já temos formato, pular
              if (!(ehFormato && jaTemFormato)) {
                configuracoesDoResumo.push(texto)
              }
            }
          }
        })
        // Adicionar configurações do resumo que não foram encontradas nas opções ativas
        if (configuracoesDoResumo.length > 0) {
          configuracoes.push(...configuracoesDoResumo)
        }
      }

      // Preparar item para adicionar ao carrinho
      const itemToAdd = {
        id: variantIdNum,
        quantity: quantityNum
      }

      // Inicializar propriedades
      itemToAdd.properties = {}

      // Adicionar apenas Modelo como propriedade (Cor e Tamanho já vêm nas opções da variante)
      if (propriedadesEspecificas['Modelo']) {
        itemToAdd.properties['Modelo'] = propriedadesEspecificas['Modelo']
      }

      // Adicionar configurações como propriedades
      configuracoes.forEach((config, index) => {
        if (config) {
          itemToAdd.properties[`Configuração ${index + 1}`] = config
        }
      })

      // Se houver preço customizado, adicionar como propriedade (em centavos)
      if (customPrice && !isNaN(parseFloat(customPrice))) {
        let precoEmReais = parseFloat(customPrice)
        let precoUnitarioEmReais = customUnitPrice && !isNaN(parseFloat(customUnitPrice)) ? parseFloat(customUnitPrice) : null

        // Garantir consistência: se temos unitário, usar ele para calcular o total correto
        // Isso garante que o total seja sempre exatamente unitário * quantidade
        if (precoUnitarioEmReais !== null) {
          const precoTotalEsperado = precoUnitarioEmReais * quantityNum
          const diferencaPercentual = Math.abs(precoEmReais - precoTotalEsperado) / precoTotalEsperado

          // Se houver diferença significativa (mais de 1%), usar o valor calculado para garantir consistência
          if (diferencaPercentual > 0.01) {
            precoEmReais = precoTotalEsperado
          }
        }

        const precoEmCentavos = Math.round(precoEmReais * 100)
        itemToAdd.properties['_preco_calculado'] = precoEmCentavos.toString()

        // Se houver preço unitário customizado, também adicionar
        if (precoUnitarioEmReais !== null) {
          const precoUnitarioEmCentavos = Math.round(precoUnitarioEmReais * 100)
          itemToAdd.properties['_preco_unitario_calculado'] = precoUnitarioEmCentavos.toString()
        }
      }

      // Verificar se existe um produto com a mesma variante e as mesmas configurações
      if (itemsComMesmaVariante.length > 0) {
        // Função para normalizar propriedades (remover propriedades internas e ordenar)
        const normalizarPropriedades = (properties) => {
          if (!properties) return {}
          const normalizadas = {}
          // Filtrar apenas propriedades de configuração (ignorar preços internos)
          Object.keys(properties).forEach(key => {
            if (!key.startsWith('_')) {
              normalizadas[key] = properties[key]
            }
          })
          return normalizadas
        }

        // Normalizar propriedades do item a ser adicionado
        const propriedadesAtuais = normalizarPropriedades(itemToAdd.properties)

        // Verificar cada item existente com a mesma variante
        const itemDuplicado = itemsComMesmaVariante.find(itemExistente => {
          const propriedadesExistentes = normalizarPropriedades(itemExistente.properties)

          // Comparar se têm o mesmo número de propriedades de configuração
          const keysAtuais = Object.keys(propriedadesAtuais).sort()
          const keysExistentes = Object.keys(propriedadesExistentes).sort()

          if (keysAtuais.length !== keysExistentes.length) {
            return false // Número diferente de configurações = não é duplicado
          }

          // Comparar cada propriedade
          for (const key of keysAtuais) {
            if (!keysExistentes.includes(key)) {
              return false // Propriedade não existe no item existente
            }
            // Comparar valores (case-insensitive e trim para evitar diferenças de formatação)
            const valorAtual = String(propriedadesAtuais[key]).trim().toLowerCase()
            const valorExistente = String(propriedadesExistentes[key]).trim().toLowerCase()
            if (valorAtual !== valorExistente) {
              return false // Valores diferentes = não é duplicado
            }
          }

          return true // Todas as propriedades são iguais = é duplicado
        })

        if (itemDuplicado) {
          // Produto com a mesma variante e configurações exatas já existe no carrinho
          // Somar a quantidade ao item existente
          const novaQuantidade = itemDuplicado.quantity + quantityNum

          try {
            const updateResponse = await fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                id: itemDuplicado.key,
                quantity: novaQuantidade
              })
            })

            if (!updateResponse.ok) {
              throw new Error('Erro ao atualizar quantidade do produto')
            }

            const updatedCartData = await updateResponse.json()

            // Atualizar contador e disparar evento
            await this.updateCartCount().catch(() => {})
            document.dispatchEvent(new CustomEvent('cart:updated'))

            // Mostrar feedback de sucesso
            this.showAlert(`Quantidade atualizada! Total: ${novaQuantidade} unidade(s)`, 'positivo')

            // Abrir o carrinho para o usuário ver a atualização
            this.abrirCarrinho()

            if (buttonElement) {
              this.hideLoading(buttonElement)
            }
            return
      } catch (error) {
        this.showAlert('Erro ao atualizar quantidade do produto. Tente novamente.', 'negativo')
            if (buttonElement) {
              this.hideLoading(buttonElement)
            }
            return
          }
        }
        // Se chegou aqui, significa que é o mesmo produto mas com configurações diferentes
        // Permitir adicionar
      }

      // Fazer requisição para adicionar ao carrinho
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [itemToAdd]
        })
      })

      // Verificar resposta
      if (!response.ok) {
        let errorMessage = 'Erro ao adicionar produto ao carrinho'

        try {
          const errorData = await response.json()
          if (errorData.description) {
            errorMessage = errorData.description
          } else if (errorData.message) {
            errorMessage = errorData.message
          }

          // Se a mensagem mencionar quantidade limitada, personalizar
          if (errorMessage.toLowerCase().includes('somente') ||
              errorMessage.toLowerCase().includes('disponibilidade') ||
              errorMessage.toLowerCase().includes('availability')) {
            errorMessage = `Nossa produção é sob demanda e não há limitação de quantidade. A quantidade solicitada (${quantityNum} unidades) deve ser adicionada ao carrinho. Por favor, verifique a configuração do produto no sistema ou entre em contato conosco.`
          }
        } catch (e) {
          // Se não conseguir parsear o erro, usar mensagem padrão
          errorMessage = `Erro ${response.status}: ${response.statusText}`
        }

        throw new Error(errorMessage)
      }

      const data = await response.json()

      // Verificar se a resposta contém erros
      if (data.errors && Object.keys(data.errors).length > 0) {
        const errorMessages = Object.values(data.errors).flat()
        let errorMsg = errorMessages.join(', ') || 'Erro ao adicionar produto ao carrinho'

        // Se o erro mencionar disponibilidade/estoque, personalizar mensagem
        if (errorMsg.toLowerCase().includes('disponibilidade') ||
            errorMsg.toLowerCase().includes('availability') ||
            errorMsg.toLowerCase().includes('estoque') ||
            errorMsg.toLowerCase().includes('stock') ||
            errorMsg.toLowerCase().includes('somente')) {
          errorMsg = 'Nossa produção é sob demanda. Por favor, verifique se o produto está configurado corretamente no sistema ou entre em contato conosco.'
        }

        throw new Error(errorMsg)
      }

      // Verificar se a quantidade adicionada foi menor que a solicitada (limitação de estoque)
      // Para produção sob demanda, isso não deveria acontecer
      if (data.items && data.items.length > 0) {
        const addedItem = data.items[0]
        if (addedItem.quantity && addedItem.quantity < quantityNum) {
          // Se a quantidade adicionada for menor, informar o usuário
          const mensagem = `Apenas ${addedItem.quantity} unidade(s) foram adicionadas ao carrinho. Nossa produção é sob demanda. Por favor, verifique a configuração do produto ou entre em contato conosco para adicionar a quantidade desejada de ${quantityNum} unidades.`
          this.showAlert(mensagem, 'negativo')
        }
      }

      // Atualizar contador do carrinho
      try {
        await this.updateCartCount()
      } catch (error) {
        // Não bloquear o fluxo se falhar ao atualizar contador
      }

      // Disparar evento personalizado para atualizar o nav
      document.dispatchEvent(new CustomEvent('cart:updated'))

      // Mostrar feedback de sucesso
      this.showAlert('Produto adicionado ao carrinho!', 'positivo')

      // Abrir o popup do carrinho automaticamente
      this.abrirCarrinho()

      // Remover loading
      if (buttonElement) {
        setTimeout(() => {
          this.hideLoading(buttonElement)
        }, 1000)
      }

      return data
    } catch (error) {
      // Mostrar mensagem de erro mais específica
      // Verificar se a mensagem é sobre limitação de estoque e personalizar
      let errorMessage = error.message || 'Erro ao adicionar produto ao carrinho!'

      // Se a mensagem mencionar disponibilidade/estoque, informar que é produção sob demanda
      if (errorMessage.toLowerCase().includes('disponibilidade') ||
          errorMessage.toLowerCase().includes('availability') ||
          errorMessage.toLowerCase().includes('estoque') ||
          errorMessage.toLowerCase().includes('stock')) {
        errorMessage = 'Nossa produção é sob demanda. Por favor, entre em contato conosco se houver alguma limitação na quantidade desejada.'
      }

      this.showAlert(errorMessage, 'negativo')

      // Remover loading em caso de erro
      if (buttonElement) {
        this.hideLoading(buttonElement)
      }

      // Não fazer throw para não quebrar o fluxo
      return null
    }
  }

  // Atualizar contador do carrinho
  async updateCartCount() {
    try {
      const response = await fetch('/cart.js')
      const cart = await response.json()

      // Usar items.length para contar produtos únicos, não item_count que conta quantidade total
      const produtosUnicos = cart.items ? cart.items.length : 0

      // Atualizar elementos do carrinho na página
      const carrinhoButtons = document.querySelectorAll('nav .botoes .padrao')
      carrinhoButtons.forEach((button) => {
        if (button.textContent.includes('templates')) {
          button.innerHTML = `
            <img src="/assets/icone-carrinho.svg" alt="Carrinho">
            ${produtosUnicos} templates
          `
        }
      })

      // Atualizar contador se existir elemento específico
      const cartCount = document.getElementById('cart-count')
      if (cartCount) {
        cartCount.textContent = produtosUnicos
      }

      // Atualizar contadorCarrinho também (usado no nav.liquid)
      const contadorCarrinho = document.getElementById('contadorCarrinho')
      if (contadorCarrinho) {
        contadorCarrinho.textContent = produtosUnicos
      }

      return cart
    } catch (error) {
      // Erro silencioso ao atualizar contador
    }
  }

  // Sistema de alertas integrado
  showAlert(mensagem, tipo = 'positivo', duracao = 4000) {
      if (window.mostrarAlerta) {
        window.mostrarAlerta(mensagem, tipo, duracao)
      }
  }

  // Abrir popup do carrinho
  abrirCarrinho() {
    // Tentar abrir modal do carrinho se existir
    const cartModal = document.getElementById('cart-modal')
    if (cartModal) {
      cartModal.classList.add('mostrar')
      return
    }

    // Se não há modal, redirecionar para página do carrinho
    setTimeout(() => {
      window.location.href = '/cart'
    }, 1500)
  }

  // Mostrar loading no botão
  showLoading(buttonElement) {
    if (buttonElement) {
      buttonElement.classList.add('loading')
      buttonElement.disabled = true
    }
  }

  // Esconder loading do botão
  hideLoading(buttonElement) {
    if (buttonElement) {
      buttonElement.classList.remove('loading')
      buttonElement.disabled = false
    }
  }


  // Ir para página do produto
  goToProduct(productUrl) {
    if (productUrl && productUrl !== '#') {
      window.location.href = productUrl
    }
  }

  // Adicionar estilos CSS apenas para loading
  addFeedbackStyles() {
    if (document.getElementById('carrinho-loading-styles')) return

    const style = document.createElement('style')
    style.id = 'carrinho-loading-styles'
    style.textContent = `
      /* Loading estados */
      .loading {
        position: relative;
        pointer-events: none !important;
      }

      .loading .icone img {
        animation: spin 1s linear infinite !important;
      }

      .loading::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.1);
        border-radius: inherit;
        animation: pulse 1s infinite;
      }

      /* Animações */
      @keyframes spin {
        from {
          transform: rotate(0deg);
        }
        to {
          transform: rotate(360deg);
        }
      }

      @keyframes pulse {
        0%, 100% {
          opacity: 0.3;
        }
        50% {
          opacity: 0.6;
        }
      }
    `

    document.head.appendChild(style)
  }
}

// Instanciar o gerenciador do carrinho
const carrinho = new CarrinhoManager()

// Funções globais para compatibilidade
window.addToCart = (variantId, quantity = 1, buttonElement = null, customPrice = null, customUnitPrice = null) => {
  return carrinho.addToCart(variantId, quantity, buttonElement, customPrice, customUnitPrice)
}

window.goToProduct = (productUrl) => {
  return carrinho.goToProduct(productUrl)
}

// Exportar para uso em módulos
if (typeof module !== 'undefined' && module.exports) {
  module.exports = CarrinhoManager
}










